var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:['m-panel__item', { 'm-panel__item--block': _vm.data.attrs.inline === false }]},[_c('span',{staticClass:"m-panel__item-label"},[_vm._v(_vm._s(_vm.data.attrs.label))]),_c('div',{staticClass:"m-panel__item-value"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }